import { NgModule } from '@angular/core';
import { CmsConfig, Config, I18nConfig, provideConfig } from 'haba-core';
import { CheckoutStepsConfig } from './checkout-steps.config';
import {
  HabaCheckoutGuard,
  HabaCheckoutAuthGuard,
  HabaCheckoutStepsSetGuard,
} from '@app/features/checkout';
import { CHECKOUT_FEATURE, CheckoutRootModule } from 'haba-featurelibs/checkout/root';
import {
  CheckoutAuthGuard,
  CheckoutGuard,
  CheckoutStepsSetGuard,
} from 'haba-featurelibs/checkout/components';
import {
  checkoutTranslationChunksConfig,
  checkoutTranslations,
} from 'haba-featurelibs/checkout/assets';
import { EMPORIX_ORDER_NORMALIZER, EmporixOrderNormalizer } from 'haba-emporix';

@NgModule({
  declarations: [],
  imports: [CheckoutRootModule],
  providers: [
    {
      provide: CheckoutAuthGuard,
      useExisting: HabaCheckoutAuthGuard,
    },
    {
      provide: CheckoutGuard,
      useClass: HabaCheckoutGuard,
    },
    {
      provide: CheckoutStepsSetGuard,
      useClass: HabaCheckoutStepsSetGuard,
    },
    provideConfig(<CmsConfig>{
      featureModules: {
        [CHECKOUT_FEATURE]: {
          module: () => import('haba-emporix').then((m) => m.CheckoutEmporixModule),
        },
        CustomCheckoutModule: {
          module: () => import('./custom-checkout.module').then((m) => m.CustomCheckoutModule),
          cmsComponents: [
            'GuestCheckoutLoginComponent',
            'ReturningCustomerCheckoutLoginComponent',
            'RegisterCustomerComponent',
            'CheckoutShippingAddress',
            'CheckoutPaymentDetails',
            'CheckoutReviewOrder',
            'OrderConfirmationThankMessageComponent',
            'CheckoutOrderSummary',
            'AuthorizePaymentComponent',
            'LoginCheckoutBottomComponent',
            'TopCheckoutLoginComponent',
            'OrderConfirmationBottomComponent',
          ],
        },
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: checkoutTranslations,
        chunks: checkoutTranslationChunksConfig,
      },
    }),
    provideConfig(CheckoutStepsConfig as Config),
    provideConfig({
      routing: {
        routes: {
          authorizePayment: { paths: ['checkout/authorize-payment'] },
        },
      },
    }),
    {
      provide: EMPORIX_ORDER_NORMALIZER,
      useExisting: EmporixOrderNormalizer,
      multi: true,
    },
  ],
})
export class CheckoutFeatureModule {}
